import React, { ReactElement } from 'react';
import { Redirect } from 'react-router-dom';

export function NotFoundRedirect (): ReactElement {
    return (
        <Redirect to="/not-found" data-testid="not-found" />
    );
}
